// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setting-feed__container {
  align-items: center;
}
.setting-feed__label {
  display: inline-block;
  width: 125px;
  margin-right: 16px;
}
.setting-feed__feed-input.g-text-input {
  width: 250px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/SettingFeed/SettingFeed.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AADR;AAII;EACI,YAAA;AAFR","sourcesContent":[".setting-feed__container {\n  align-items: center;\n}\n.setting-feed__label {\n  display: inline-block;\n  width: 125px;\n  margin-right: 16px;\n}\n.setting-feed__feed-input.g-text-input {\n  width: 250px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
